type FlairPeakProps = {
  className?: string;
  width: number;
  height: number;
  ariaLabel: string;
};

const FlairPeak = ({ className, width, height, ariaLabel }: FlairPeakProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 12 12"
    role="img"
    aria-label={ariaLabel}
  >
    <path
      fill="#ac76f6"
      stroke="white"
      strokeWidth="1.5"
      paintOrder="stroke"
      filter="drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.3))"
      d="M6 1.232c-1.578 0-6.546 8.694-5.617 9.623.928.928 3.719-2.776 5.617-2.776s4.689 3.704 5.617 2.776c.93-.93-4.04-9.623-5.617-9.623"
    />
  </svg>
);

export default FlairPeak;
